require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var e,
    t = require("react"),
    r = (e = t) && "object" == typeof e && "default" in e ? e["default"] : e,
    n = r.createContext({
  store: null
});

function o(e, t, r) {
  return t in e ? Object.defineProperty(e, t, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = r, e;
}

function u(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = null != arguments[t] ? arguments[t] : {},
        n = Object.keys(r);
    "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function (e) {
      return Object.getOwnPropertyDescriptor(r, e).enumerable;
    }))), n.forEach(function (t) {
      o(e, t, r[t]);
    });
  }

  return e;
}

function c(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var r = [],
        n = !0,
        o = !1,
        u = void 0;

    try {
      for (var c, i = e[Symbol.iterator](); !(n = (c = i.next()).done) && (r.push(c.value), !t || r.length !== t); n = !0) {
        ;
      }
    } catch (e) {
      o = !0, u = e;
    } finally {
      try {
        n || null == i["return"] || i["return"]();
      } finally {
        if (o) throw u;
      }
    }

    return r;
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }();
}

exports.ReduxBundlerContext = n, exports.ReduxBundlerProvider = function (e) {
  return r.createElement(n.Provider, {
    value: {
      store: e.store
    }
  }, e.children);
}, exports.useConnect = function () {
  for (var e = arguments, r = arguments.length, o = new Array(r), i = 0; i < r; i++) {
    o[i] = e[i];
  }

  var a = t.useContext(n).store,
      f = c(t.useMemo(function () {
    return function (e, t) {
      var r = [],
          n = {};
      return t.forEach(function (t) {
        if (t.startsWith("select")) r.push(t);else {
          if (!t.startsWith("do")) throw Error("Cannot Connect: ".concat(t));

          n[t] = function () {
            for (var r = arguments, n = arguments.length, o = new Array(n), u = 0; u < n; u++) {
              o[u] = r[u];
            }

            return e.action ? e.action(t, o) : e[t].apply(e, o);
          };
        }
      }), [r, n];
    }(a, o);
  }, o), 2),
      l = f[0],
      s = f[1],
      y = c(t.useState(function () {
    return a.select(l);
  }), 2),
      d = y[0],
      p = y[1],
      b = t.useRef(l);
  return t.useEffect(function () {
    return b.current !== l && (b.current = l, p(a.select(l))), a.subscribeToSelectors(l, function (e) {
      p(function (t) {
        return u({}, t, e);
      });
    });
  }, [l]), u({}, s, b.current !== l ? a.select(l) : d);
}, exports.useReduxBundlerStore = function () {
  return t.useContext(n).store;
};